import React, { useEffect, useState } from 'react';
import Textbox from '../../styled/TextInput';

interface IQuantityProps {
  disabled: boolean;
  quantity: any;
  onChange: (arg: number) => void;
}

const QuantityDropdownInput = ({ disabled, quantity, onChange }: IQuantityProps) => {
  const [valueChange, setValueChange] = useState(quantity);

  // Submit Form when the Quantity more than 10
  const SubmitQuantityValue = (
    event: React.FormEvent<HTMLFormElement> | React.FocusEvent<HTMLInputElement>,
  ) => {
    event.preventDefault();
    const value = Math.max(1, parseInt(valueChange, 10));
    onChange(value);
    setValueChange(quantity);
  };

  useEffect(() => {
    setValueChange(quantity);
  }, [quantity]);

  // Handle selected Quantity
  const onQuantityValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueChange(event.target.value);
  };
  return (
    <>
      {
        <form method="POST" onSubmit={SubmitQuantityValue}>
          <Textbox
            autoComplete="off"
            disabled={disabled}
            id="textBox"
            label="Antal"
            name="quantity"
            type="number"
            onBlur={SubmitQuantityValue}
            onChange={onQuantityValueChange}
            value={valueChange}
          />
        </form>
      }
    </>
  );
};

export default QuantityDropdownInput;
